var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#1A3EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4464 17.4792L12.4884 17.4792C10.7657 17.4792 9.75233 18.1144 8.917 18.9497C8.13993 19.7268 7.86434 20.6622 7.7722 21.3345C7.70301 21.8393 8.12602 22.2271 8.63557 22.2271L17.0322 22.2271C17.2974 22.2271 17.5518 22.1217 17.7393 21.9342L21.5292 18.1442C21.9197 17.7537 21.9197 17.1206 21.5292 16.73L19.1535 14.3543C18.5236 13.7244 17.4464 14.1705 17.4464 15.0614L17.4464 16.4792C17.4464 17.0314 16.9987 17.4792 16.4464 17.4792Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5184 12.5633L17.4764 12.5633C19.1991 12.5633 20.2125 11.9281 21.0478 11.0927C21.8249 10.3157 22.1005 9.38024 22.1926 8.70802C22.2618 8.20319 21.8388 7.81543 21.3293 7.81543L12.9326 7.81543C12.6674 7.81543 12.4131 7.92079 12.2255 8.10832L8.43562 11.8982C8.0451 12.2888 8.0451 12.9219 8.43562 13.3125L10.8113 15.6882C11.4413 16.3181 12.5184 15.872 12.5184 14.981L12.5184 13.5633C12.5184 13.011 12.9661 12.5633 13.5184 12.5633Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.39093f39.svg";
export { ForwardRef as ReactComponent };